import {GetAppointmentAttachmentsParams} from 'domain/usecases';
import {makeGetAppointmentAttachments} from 'main/factories/usecases/private/my-appointments';

export const getAppointmentAttachments = async (params: GetAppointmentAttachmentsParams) =>
	makeGetAppointmentAttachments().get(params);
